module.exports = __webpack_public_path__ + "img/essilor.d650001a.png";